module.exports = __webpack_public_path__ + "static/img/72.ddd9a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/72.png
// module id = N12A
// module chunks = 0